<template>
  <div class="fieldGroup mt-4 mb-4">
    <label v-if="block && block.fieldObject && block.fieldObject.label">{{block.fieldObject.label}}</label>
    <div :style="cssVars" class="blocks flex-wrap">
      <template v-for="block in blocks">
        <block v-if="block.type_id=='field'" :key="block.id" :block="block" />
        <field-group v-else :key="block.id" :blocks="block.blocks" :block="block" />
      </template>
    </div>
  </div>
</template>
<script>
import Block from "./Block.vue";
export default {
  name: "FieldGroup",
  components: {
    Block
  },
  props: {
    blocks: {
      type: Array,
      required: true
    },
    block: {
      type: Object
    },
    flexDirection: {
      type: String,
      default: "row"
    }
  },
  computed: {
    cssVars() {
      return {
        "--flex-direction": this.flexDirection
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.fieldGroup {
  .blocks {
    display: flex;
    flex-direction: var(--flex-direction);
    box-sizing: content-box;
    > label {
      flex: 0 0 100%;
    }
    .block {
      flex: 1 1 auto;
      margin: 10px 0;
    }
  }
}
</style>
